import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './productpagelistcard.module.css';
import ProductCard from '../ProductCard';
import { useTranslation } from "react-i18next";


const products = new Array(75).fill(null).map((_, index) => ({
    id: index + 1,
    product_name: `Product 1`,
    price: `${(index + 1) * 1000} đ`,
}));

const ProductGrid = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 16;
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentPage]);

    const handleClickNext = () => {
        setCurrentPage(prevPage => Math.min(prevPage + 1, Math.ceil(products.length / productsPerPage)));
    };

    const handleClickPrev = () => {
        setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    };

    const handlePageClick = (pageNum) => {
        setCurrentPage(pageNum);
    };

    const renderProducts = () => {
        const startIndex = (currentPage - 1) * productsPerPage;
        const currentProducts = products.slice(startIndex, startIndex + productsPerPage);

        return currentProducts.map(product => (
            <div className="col-md-3 mb-4" key={product.id}>
                <ProductCard 
                img={product.img} 
                product_name={product.product_name} 
                price={product.price} />
            </div>
        ));
    };

    const renderPagination = () => {
        const totalPages = Math.ceil(products.length / productsPerPage);
        const pages = [];

        for (let i = 1; i <= totalPages; i++) {
            pages.push(
                <button
                    key={i}
                    className={`btn btn-link ${styles.paginationButton} ${currentPage === i ? styles.activePage : ''}`}
                    onClick={() => handlePageClick(i)}
                >
                    {i}
                </button>
            );
        }

        return (
            <div className="d-flex justify-content-center align-items-center">
                <button
                    className={`btn btn-link ${styles.paginationButton}`}
                    onClick={handleClickPrev}
                    disabled={currentPage === 1}
                >
                    &lt;
                </button>
                {pages}
                <button
                    className={`btn btn-link ${styles.paginationButton}`}
                    onClick={handleClickNext}
                    disabled={currentPage === totalPages}
                >
                    &gt;
                </button>
            </div>
        );
    };

    return (
        <div className="container mt-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4>{t("sorted_by")}</h4>
                <select className="form-select w-auto">
                    <option value="default">{t("default")}</option>
                    <option value="price_asc">{t("increase_price")}</option>
                    <option value="price_desc">{t("decrease_price")}</option>
                </select>
            </div>
            <div className="row">
                {renderProducts()}
            </div>
            <div className="mt-4">
                {renderPagination()}
            </div>
        </div>
    );
};

export default ProductGrid;
